import { Col, Row } from 'reactstrap';
import { Icon } from '@octano/global-ui';
import useTexts from '../../../hooks/useTexts';

export function PastReservationsContent() {
  const texts = useTexts();

  return (
    <>
      <Row className="justify-content-center mt-4">
        <Col xs="auto">
          <Icon name="warning" size="60" />
        </Col>
      </Row>
      <p className="text-dark fs-22 mt-3 mb-4 text-center">
        {texts.delete.cannotDelete}
      </p>
      <div className="fs-18 text-center mb-1">{texts.delete.hasPastEvents}</div>
      <div className="fs-18 text-center">
        {texts.delete.hasPastEventsSubtitle}
      </div>
    </>
  );
}
